import { PackServiceContext } from "../ServicePage/context/PackServiceContext"
import React, { useContext } from "react"

export const withPackContext = (WrappedPage) => {
  return (props) => {
    const { packContext, changePackContext, selectedPack, setSelectedPack } = useContext(PackServiceContext)
    const packProps = {
      packContext,
      changePackContext,
      selectedPack,
      setSelectedPack
    }

    return <WrappedPage {...props} {...packProps} />
  }
}
